import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";

import { WorkOrderBase } from "../WorkOrder/WorkOrderBase";
import { getCachedItem } from "../../helpers";

const findById = (arr, id) => {
  const item = arr?.find((i) => i.id === id);
  if (!item) return undefined;
  return item.label && !item.name ? { ...item, name: item.label } : item;
};

const transformPartDataToWorkOrderPreview = (formValues) => {
  const details = formValues?.details || {};
  const instructions = Array.isArray(formValues?.instructions)
    ? formValues.instructions
    : [];

  const customers = getCachedItem("customers") || [];
  const materialsCache = getCachedItem("materials");
  const allMaterials = materialsCache?.materials || [];
  const trees = materialsCache?.trees || [];

  const material = details.materialId
    ? findById(allMaterials, details.materialId)
    : undefined;
  const tree = details.treeId ? findById(trees, details.treeId) : undefined;

  const firstCustomerId = details?.customerIds?.[0];
  const customerData = firstCustomerId
    ? findById(customers, firstCustomerId)
    : null;
  const customerName = customerData?.name || "Customer Name (TBD)";

  return {
    workOrder: "PR-000000-0",
    quantity: 0,
    quantityReq: 0,
    lotNumber: "00-00",
    trees: 0,
    price: details?.lastSentPrice || 0,
    createdAt: new Date().toISOString(),
    shipVia: null,
    address: null,
    freight: null,

    order: { poNumber: "PO-XXXXX" },
    customer: { name: customerName },
    lineItem: {
      lineNumber: "PR-000000",
      quantity: 0,
      dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    },

    material,
    tree,
    details: {
      partsPerTree: details?.partsPerTree,
      materialId: details?.materialId,
      treeId: details?.treeId,
    },

    part: {
      partNumber: details?.partNumber || "",
      partName: details?.partName || "",
      weight: details?.weight,
    },
    instructions,
  };
};

export const PartWorkOrderPreview = () => {
  const { watch } = useFormContext();
  const formValues = watch();

  const workOrderPreviewData = useMemo(
    () => transformPartDataToWorkOrderPreview(formValues),
    [formValues],
  );

  return (
    <WorkOrderBase
      id="part-work-order-preview"
      data={workOrderPreviewData}
      isLoading={false}
      sx={{ height: "100%", padding: "15px" }}
    />
  );
};

export default PartWorkOrderPreview;
